import { render } from "./TopDishesTable.vue?vue&type=template&id=fead218e"
import script from "./TopDishesTable.vue?vue&type=script&lang=js"
export * from "./TopDishesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__